import React from 'react';
import './DeleteButton.scss';
interface IDeleteProps {
  row: any;
  deleter: (row: any) => Promise<void>;
  disabled?: boolean;
}

const DeleteButton: React.FC<IDeleteProps> = props => {
  const { row, deleter, disabled } = props;
  return <button className="fa fa-minus-circle" onClick={deleter.bind({}, row)} disabled={disabled} />;
};

export default DeleteButton;
